const MINUTE = 60;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

const count = (n, unit) => `${n} ${unit}${n === 1 ? '' : 's'}`;

/**
 * How long before `now` an instant was, in words: "2 hours ago", "1 day ago". Rounded down, so it
 * never claims more time has passed than has.
 *
 * `now` is passed in, not read from the browser: pass the server's time when the instant came from
 * the server, so a wrong clock on this computer cannot change the answer.
 *
 * @param {string|number|Date} then
 * @param {string|number|Date} now
 * @returns {string} '' when either is missing or unparseable
 */
export function timeAgo(then, now) {
    if (!then || !now) {
        return '';
    }

    const elapsedMs = new Date(now).getTime() - new Date(then).getTime();

    if (isNaN(elapsedMs)) {
        return '';
    }

    // An instant a little after `now` (another server's clock) reads as just now.
    const seconds = Math.max(0, Math.floor(elapsedMs / 1000));

    if (seconds < MINUTE) {
        return 'less than a minute ago';
    }
    if (seconds < HOUR) {
        return `${count(Math.floor(seconds / MINUTE), 'minute')} ago`;
    }
    if (seconds < DAY) {
        return `${count(Math.floor(seconds / HOUR), 'hour')} ago`;
    }

    const days = Math.floor(seconds / DAY);

    if (days < 30) {
        return `${count(days, 'day')} ago`;
    }
    if (days < 365) {
        return `${count(Math.min(11, Math.floor(days / 30)), 'month')} ago`;
    }

    return `${count(Math.floor(days / 365), 'year')} ago`;
}
